/**
 * Node Modules
 */
import React, {useState, useEffect} from 'react'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'

/**
 * Component
 */

function Chevron(props) {
  return (
    <button {...props}>
     <svg width={13} height={23} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
      <defs>
        <path id="prefix__a" d="M0 0h26v43H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M-325-415H50v807h-375z" />
        <g transform="translate(0 -10)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M12.828 20.855L6.196 10.313c-.125-.199-.304-.313-.491-.313H.664c-.569 0-.879.98-.491 1.603L6.53 21.5.173 31.397C-.213 32.017.09 33 .663 33h5.042c.187 0 .366-.115.491-.314l6.632-10.542c.23-.365.23-.923 0-1.289"
            fill="#FF7F57"
            fillRule="nonzero"
            mask="url(#prefix__b)"
          />
        </g>
      </g>
    </svg>
    </button>
  )
}

export default function OurAdvisors({ hed, dek, advisorDetails }) {
  const [index, setIndex] = useState(0)
  const maxIndex = advisorDetails.length;

  const handleNext = () => {
    setIndex((index + 1) % maxIndex)
  }

  const handlePrevious = () => {
    setIndex((maxIndex + index - 1) % maxIndex)
  }

  console.log(index)

  return (
    <Section className="our-advisors" id="our-advisors">
      <svg className="our-advisors__baseboard-curve" viewBox="0 0 1280 297">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FFFFFF"
            d="M1281 295H.998v-21.173c94.798-83.092 206.66-124.638 335.587-124.638 203.69 0 284.194 64.254 493.125 64.254 194.752 0 255.651-187.194 451.283-212.601L1281 295z"
          />
        </g>
      </svg>

      <div className="our-advisors__grid-copy grid">
        <h2 className="our-advisors__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {hed}
        </h2>
        <p className="our-advisors__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {dek}
        </p>
      </div>
      <div className="our-advisors__grid-wrapper">
        <Chevron className="reset our-advisors__previous" onClick={handlePrevious} />
        <Chevron className="reset our-advisors__next" onClick={handleNext} />

        <div className="our-advisors__grid-list grid">
          <div className={`clearfix our-advisors__advisor-item ${index === 0 ? 'active' : ''} column-start-1 column-start-3--t column-start-1--d column-end-6 column-end-10--t column-end-6--d`}>
            <img
              className="our-advisors__advisor-image"
              src={advisorDetails[0].image}
              alt={advisorDetails[0].name}
            />
            <div className="our-advisors__advisor-copy">
              <span className="our-advisors__advisor-name">{advisorDetails[0].name}</span>
              <span className="our-advisors__advisor-title">{advisorDetails[0].brand}</span>
              <p className="our-advisors__advisor-bio">{advisorDetails[0].dek}</p>
            </div>
          </div>
          <div className={`clearfix our-advisors__advisor-item ${index === 1 ? 'active' : ''} column-start-1 column-start-3--t column-end-6  column-start-7--d column-end-10--t column-end-12--d`}>
            <img
              className="our-advisors__advisor-image"
              src={advisorDetails[1].image}
              alt={advisorDetails[1].name}
            />
            <div className="our-advisors__advisor-copy">
              <span className="our-advisors__advisor-name">{advisorDetails[1].name}</span>
              <span className="our-advisors__advisor-title">{advisorDetails[1].brand}</span>
              <p className="our-advisors__advisor-bio">{advisorDetails[1].dek}</p>
            </div>
          </div>
          <div className={`clearfix our-advisors__advisor-item ${index === 2 ? 'active' : ''} column-start-1 column-start-3--t column-start-1--d column-end-6 column-end-10--t column-end-6--d`}>
            <img
              className="our-advisors__advisor-image"
              src={advisorDetails[2].image}
              alt={advisorDetails[2].name}
            />
            <div className="our-advisors__advisor-copy">
              <span className="our-advisors__advisor-name">{advisorDetails[2].name}</span>
              <span className="our-advisors__advisor-title">{advisorDetails[2].brand}</span>
              <p className="our-advisors__advisor-bio">{advisorDetails[2].dek}</p>
            </div>
          </div>
          <div className={`clearfix our-advisors__advisor-item ${index === 3 ? 'active' : ''} column-start-1 column-start-3--t column-start-1--d column-end-6  column-start-7--d column-end-10--t column-end-12--d`}>
            <img
              className="our-advisors__advisor-image"
              src={advisorDetails[3].image}
              alt={advisorDetails[3].name}
            />
            <div className="our-advisors__advisor-copy">
              <span className="our-advisors__advisor-name">{advisorDetails[3].name}</span>
              <span className="our-advisors__advisor-title">{advisorDetails[3].brand}</span>
              <p className="our-advisors__advisor-bio">{advisorDetails[3].dek}</p>
            </div>
          </div>
          <div className={`clearfix our-advisors__advisor-item ${index === 4 ? 'active' : ''} column-start-1 column-start-3--t column-start-1--d column-end-6 column-end-10--t column-end-6--d`}>
            <img
              className="our-advisors__advisor-image"
              src={advisorDetails[4].image}
              alt={advisorDetails[4].name}
            />
            <div className="our-advisors__advisor-copy">
              <span className="our-advisors__advisor-name">{advisorDetails[4].name}</span>
              <span className="our-advisors__advisor-title">{advisorDetails[4].brand}</span>
              <p className="our-advisors__advisor-bio">{advisorDetails[4].dek}</p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}
